/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_W1Inputs */

const en_mk_cmp_clickup_w1 = /** @type {(inputs: Mk_Cmp_Clickup_W1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You genuinely need docs, whiteboards, goals and time tracking in one product.`)
};

const id_mk_cmp_clickup_w1 = /** @type {(inputs: Mk_Cmp_Clickup_W1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda memang membutuhkan dokumen, papan tulis, tujuan, dan pelacak waktu dalam satu produk.`)
};

/**
* | output |
* | --- |
* | "You genuinely need docs, whiteboards, goals and time tracking in one product." |
*
* @param {Mk_Cmp_Clickup_W1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_w1 = /** @type {((inputs?: Mk_Cmp_Clickup_W1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_W1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_w1(inputs)
	return en_mk_cmp_clickup_w1(inputs)
});